import { render, staticRenderFns } from "./ModalSendForm.vue?vue&type=template&id=4fcfe668"
import script from "./ModalSendForm.vue?vue&type=script&lang=js"
export * from "./ModalSendForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports